export default __webpack_public_path__ + "static/tennents-logo-full@2x-0c4e94f8f2055477f309a9d446430678.png";